<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider vid="issues_authenticity" name="issues_authenticity" rules="required" v-slot="{ errors }">
              <small class="label">Please provide details of any historic or emerging
                issues related to authenticity of this product
                and/or raw materials
              </small>
              <vs-textarea :disabled="__isDisabledRawMaterial(status)" v-model="form.issues_authenticity" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider vid="testing_controls_authenticity" name="testing_controls_authenticity" rules="required" v-slot="{ errors }">
              <small class="label">Details on testing and controls in place to ensure
                product authenticity and to prevent substitution
                and fraud
              </small>
              <vs-textarea :disabled="__isDisabledRawMaterial(status)" v-model="form.testing_controls_authenticity" />
              <span class="text-danger text-sm mt-0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_product_authenticity_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_product_authenticity_complete ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialProductAuthenticity(this.id, this.form))
          this.showSuccessMessage('Raw Material Product Authenticity Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialProductAuthenticity(this.form))
          this.showSuccessMessage('Raw Material Product Authenticity Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialProductAuthenticity(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_product_authenticity_complete) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
